import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetLuckyWheel from '@/modules/promotion/api/hooks/useQueryGetLuckyWheel'
import LuckyWheelListing from '@/modules/promotion/components/LuckyWheel/components/LuckyWheelListing'

function LuckyWheelPage() {
	const { data, isLoading } = useQueryGetLuckyWheel()

	return (
		<PageContainer>
			<LuckyWheelListing data={data ? [data] : []} isLoading={isLoading} />
		</PageContainer>
	)
}

const GuardedLuckyWheelPage = withUserPermission(LuckyWheelPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_LUCKY_WHEEL],
})

export default GuardedLuckyWheelPage
